import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { ContactSocials, SocialItem } from 'client/bundles/types';

import Icon from 'client/components/icon';
import Link from 'client/components/link';

import './index.css';

const b = cn('socials');

interface Props {
    socials: ContactSocials;
}

export default class Socials extends Component<Props> {
    renderSocialItem = (item: SocialItem, i: number) => {
        if (!item.text || !item.url) {
            return;
        }

        return (
            <li className={b('list-item')} key={i}>
                <Link href={item.url} target="_blank">
                    <Icon type={item.icon} size="36" />

                    <span
                        className={b('text')}
                        dangerouslySetInnerHTML={{ __html: item.text }}
                        />
                </Link>
            </li>
        );
    }

    render() {
        const { socials } = this.props;

        if (!socials || socials.items?.length === 0) {
            return null;
        }

        return (
            <div className={b()}>
                <h5 className={b('title')}>{socials.title}</h5>

                <ul className={b('list')}>
                    {socials.items.map(this.renderSocialItem)}
                </ul>
            </div>
        );
    }
}
